<template>
  <div>
    <el-row>
      <div class="model-header">
        <h2>Cấu hình website</h2>
        <el-button @click="backModel" size="small" class="btn-back">Trờ về</el-button>
      </div>
    </el-row>
    <el-row>
      <div class="model-content">
        <el-col :span="20">
          <el-form label-position="right" :model="modelData" ref="createModel">
            <el-tabs v-model="activeName">
              <el-tab-pane label="Thông tin chung" name="first">
                <el-form-item prop="name_company" label="Tên công ty" class="form-item">
                  <el-input v-model="modelData.name_company" class="input-seach"></el-input>
                </el-form-item>
                <el-form-item prop="solugan" label="Solugan" class="form-item">
                  <el-input v-model="modelData.solugan" class="input-seach"></el-input>
                </el-form-item>
                <el-form-item prop="description" label="VPS" class="form-item">
                  <el-input v-model="modelData.description" class="input-seach"></el-input>
                </el-form-item>
                <el-form-item prop="address" label="Địa chỉ" class="form-item">
                  <el-input v-model="modelData.address" class="input-seach"></el-input>
                </el-form-item>
                <el-form-item prop="email_1" label="Email" class="form-item"
                  :rules="[
                    { type: 'email', message: 'Email không đúng định dạng' }
                  ]">
                  <el-input v-model="modelData.email_1" class="input-seach"></el-input>
                </el-form-item>
                <el-form-item prop="phone_1" label="Số điện thoại" class="form-item">
                  <el-input v-model="modelData.phone_1" class="input-seach" auto-complete="off"></el-input>
                </el-form-item>
              </el-tab-pane>
              <el-tab-pane label="Liên hệ" name="second">
                <el-form-item prop="skype_1" label="Skype" class="form-item">
                  <el-input v-model="modelData.skype_1" class="input-seach"></el-input>
                </el-form-item>
                <el-form-item prop="yahoo_1" label="Yahoo" class="form-item">
                  <el-input v-model="modelData.yahoo_1" class="input-seach"></el-input>
                </el-form-item>
              </el-tab-pane>
              <el-tab-pane label="Mạng xã hội" name="third">
                <el-form-item prop="facebook" label="Kết nối Facebook" class="form-item">
                  <el-input v-model="modelData.facebook" class="input-seach"></el-input>
                </el-form-item>
                <el-form-item prop="youtube" label="Kết nối Youtube" class="form-item">
                  <el-input v-model="modelData.youtube" class="input-seach"></el-input>
                </el-form-item>
                <el-form-item prop="googleplus" label="Kết nối Google+" class="form-item">
                  <el-input v-model="modelData.googleplus" class="input-seach"></el-input>
                </el-form-item>
                <el-form-item prop="zalo" label="Kết nối Zalo" class="form-item">
                  <el-input v-model="modelData.zalo" class="input-seach"></el-input>
                </el-form-item>
              </el-tab-pane>
              <el-tab-pane label="Cấu hình SEO Website" name="five">
                <el-form-item prop="meta_title" label="Thẻ Meta Title" class="form-item">
                  <el-input v-model="modelData.meta_title" class="input-seach"></el-input>
                </el-form-item>
                <el-form-item prop="meta_keyword" label="Thẻ Meta Keyword" class="form-item">
                  <el-input v-model="modelData.meta_keyword" class="input-seach"></el-input>
                </el-form-item>
                <el-form-item prop="meta_description" label="Thẻ Meta Description" class="form-item">
                  <el-input v-model="modelData.meta_description" class="input-seach"></el-input>
                </el-form-item>
              </el-tab-pane>
             </el-tabs>
            <el-form-item>
                <el-button
                  :disable="!canSubmit"
                  :loading="!canSubmit"
                  type="warning"
                  size="small"
                  @click="submitForm('createModel')">Cập nhật</el-button>
                <el-button
                  size="small"
                  class="btn-back"
                  @click="backModel">Trở về
                </el-button>
              </el-form-item>
          </el-form>
        </el-col>
      </div>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios'
import { head } from 'lodash'
import { mapActions } from 'vuex'
import tinymce from 'vue-tinymce-editor'
import ls from 'local-storage'
export default {
  name: 'SettingUpdate',
  components: {
    tinymce
  },
  metaInfo () {
    return {
      title: 'Cấu hình'
    }
  },
  data () {
    return {
      canSubmit: true,
      activeName: 'first',
      tinymce: {
        toolbar1: 'undo redo formatselect fontsizeselect | bold italic strikethrough forecolor backcolor | link | alignleft aligncenter alignright alignjustify | numlist bullist outdent indent'
      },
      modelData: {
        logo: '',
        name_company: '',
        solugan: '',
        address: '',
        email_1: '',
        email_2: '',
        email_3: '',
        phone_1: '',
        phone_2: '',
        phone_3: '',
        skype_1: '',
        skype_2: '',
        skype_3: '',
        yahoo_1: '',
        yahoo_2: '',
        yahoo_3: '',
        meta_title: '',
        meta_keyword: '',
        meta_description: '',
        meta_short_description: '',
        meta_js_codes: '',
        about_us: '',
        facebook: '',
        googleplus: '',
        youtube: '',
        twitter: '',
        linkin: '',
        ratio_vnd_kha: 0,
        money_active: '',
        time_api: '',
        money_click: '',
        money_click_not_login: '',
        money_max: '',
        ads_detail: '',
        ads_index: ''
      },
      upload: {
        uploadProcess: false,
        url: process.env.API_URI + 'settings/upload',
        headers: {
          Authorization: ''
        }
      }
    }
  },
  mounted () {
    this.configBreadcrumb()
    this.fetchModel()
    this.configUpload()
  },
  methods: {
    // Lấy action từ Vuex
    ...mapActions(['setBreadcrumb']),
    // Cấu hình Breadcrumb
    configBreadcrumb () {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' },
        { name: 'settings-update', text: 'Cấu hình hệ thống' }
      ]
      this.setBreadcrumb(breadcrumb)
    },
    // Cấu hình Upload
    configUpload () {
      const token = ls.get('authen', '')
      if (token) {
        this.upload.headers.Authorization = `Bearer ${token.access_token}`
      } else {
        this.upload.headers.Authorization = 'Bearer'
      }
    },
    // Nút back lại trang Index
    backModel () {
      this.$router.push({name: 'home-index'})
    },
    // Tải dữ liệu Model xuống
    fetchModel () {
      this.canSubmit = false
      axios.get('settings/' + this.$route.params.id).then(response => {
        switch (response.code) {
          case 200:
            this.canSubmit = true
            this.modelData = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Lưu dữ liệu
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.updateModel()
        } else {
          this.$notify({
            title: 'Lỗi dữ liệu nhập',
            message: 'Vui lòng kiểm tra lại thông tin',
            type: 'warning'
          })
          return false
        }
      })
    },
    updateModel () {
      this.canSubmit = false
      axios.put('settings/' + this.$route.params.id, this.modelData).then(response => {
        this.canSubmit = true
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Cập nhật cấu hình hệ thống thành công',
              type: 'success'
            })
            // this.$router.push({name: 'settings-index'})
            this.$router.push({name: 'settings-update', params: {id: this.$route.params.id}})
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Upload Ảnh
    beforeAvatarUpload (file) {
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isLt2M) {
        this.$message.error('Ảnh trường có dung lượng ảnh tối đa là 2M')
      }
      return isLt2M
    },
    handleAvatarSuccess (response) {
      this.upload.uploadProcess = false
      if (response.code) {
        this.modelData.logo = response.data.name
        this.modelData.logo_path = response.data.path_sm
      }
    },
    handleAvatarProcess (event, file, fileList) {
      this.upload.uploadProcess = true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
.model-content {
  padding-top: 15px;
}
</style>
<style type="text/css">
.course-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.course-uploader .el-upload:hover {
  border-color: #409EFF;
}
.course-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 280px;
  height: 200px;
  line-height: 200px !important;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/settings/Update.vue